import { Utilities } from 'core/domains';

import type { SelectorReturnFn, UseQuery } from './hooks';

/**
 * Query State Hook
 *
 */
export function useQueryState<D = any, P = string>(
  useSelectorFn: (params?: P) => SelectorReturnFn<D>,
  params?: P,
): UseQuery<D> {
  const result = useSelectorFn(params);

  return {
    data: result?.data || ({} as D),
    dataUpdatedAt: result?.updatedAt || 0,
    isError: result?.status === Utilities.STATUS.ERROR || false,
    isIdle: result?.status ? result?.status === Utilities.STATUS.IDLE : true,
    isLoading: result?.status === Utilities.STATUS.RUNNING || false,
    isSuccess: result?.status === Utilities.STATUS.SUCCESS || false,
  };
}
